import { render, staticRenderFns } from "./BrIndicator.vue?vue&type=template&id=7d3a6c7a&scoped=true&"
import script from "./BrIndicator.vue?vue&type=script&lang=js&"
export * from "./BrIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BrIndicator.vue?vue&type=style&index=0&id=7d3a6c7a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3a6c7a",
  null
  
)

export default component.exports